import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconPaths } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { RowActions } from 'app/components'
import { DispositivoGestaoList } from '../../../core/_models'
import { getDispositivoGestao } from '../../../core/_requests'
import { rotuloDispositivo } from '../../../core/rotulos'
import { useEditarDispositivo } from '../../../components/modal/useEditarDispositivo'

export const DispositivosActionsCell: FC<{ dispositivo: DispositivoGestaoList }> = ({
  dispositivo,
}) => {
  const navigate = useNavigate()
  const { t } = useT()
  const editar = useEditarDispositivo()
  const nome = rotuloDispositivo(t, dispositivo)

  return (
    <RowActions
      itemName={nome}
      primaryAction={{
        label: t('pagina.dispositivos.acao.ver_detalhe'),
        onClick: () => navigate(`/apps/admin/dispositivos/${dispositivo.id}`),
        icon: IconPaths.Eye,
      }}
      items={[
        {
          label: t('common.edit'),
          // A linha da lista não tem o cadastro completo: busca o detalhe ao abrir.
          onClick: () => editar(nome, () => getDispositivoGestao(dispositivo.id)),
        },
      ]}
    />
  )
}
